import AnimatedEmoji from "@components/AnimatedEmoji"
import { motion } from "framer-motion"
import { Sparkles } from "lucide-react"

interface AnimatedContentProps {
  emoji: string
  heading: string
  description: string
}

export default function AnimatedContent({
  emoji,
  heading,
  description,
}: AnimatedContentProps) {
  return (
    <div className="relative flex grow flex-col overflow-hidden">
      {/* Sparkle effects - completely random placement */}
      <div className="pointer-events-none absolute inset-0">
        {Array.from({ length: 8 }).map((_, i) => (
          <motion.div
            key={i}
            className="absolute"
            style={{
              // eslint-disable-next-line react-hooks/purity
              left: `${Math.random() * 100}%`,
              // eslint-disable-next-line react-hooks/purity
              top: `${Math.random() * 100}%`,
            }}
            animate={{
              scale: [0, 1, 0],
              opacity: [0, 1, 0],
              rotate: [0, 180],
            }}
            transition={{
              duration: 2,
              delay: i * 0.2,
              repeat: Infinity,
              repeatDelay: 1,
            }}
          >
            <Sparkles className="h-4 w-4 text-purple-400" />
          </motion.div>
        ))}
      </div>

      <div className="relative z-10 flex grow flex-col items-center justify-center space-y-8 px-6">
        {/* Animated emoji */}
        <AnimatedEmoji emoji={emoji} />

        {/* Title and description */}
        <div className="space-y-4 text-center">
          <h1 className="heading">{heading}</h1>
          <p className="text-text-secondary mx-auto max-w-md leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </div>
  )
}
